<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} USER
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <vs-input
          label="Username"
          v-model="username"
          class="mt-5 w-full"
          name="username"
          v-validate="'required|alpha'"
        />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{
          errors.first("username")
        }}</span>

        <vs-input
          label="Password"
          v-model="password"
          class="mt-5 mb-2 w-full"
          name="password"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('password')">{{
          errors.first("password")
        }}</span>

        <vs-divider>Other</vs-divider>

        <vs-input
          label="Name"
          v-model="name"
          class="mt-3 w-full"
          name="name"
          v-validate="'required|min:4'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        <vs-input
          label="Email"
          v-model="email"
          class="mt-3 w-full"
          name="email"
          v-validate="'email'"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>

        <vs-input
          label="Phone"
          v-model="phone"
          class="mt-5 w-full"
          name="phone"
          v-validate="'required|numeric|max:10|min:10'"
        />
        <span class="text-danger text-sm" v-show="errors.has('phone')">{{
          errors.first("phone")
        }}</span>
        <br />
        <small class="mt-5">Role</small>
        <v-select
          class="inputx w-full"
          v-model="role"
          name="role"
          :options="roles"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('role')">{{
          errors.first("role")
        }}</span>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { _id, username, password, name, email, phone, role } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.id = _id;
        this.username = username;
        this.password = password;
        this.name = name;
        this.email = email;
        this.phone = phone;
        this.role = role;
        this.initValues();
      }
    },
  },
  data() {
    return {
      id: null,
      username: "",
      password: "",
      name: "",
      email: "",
      phone: "",
      role: null,
      roles: [
        {
          role: "fm",
          label: "Field Manager",
        },
        {
          role: "acc",
          label: "Accountant",
        },
        {
          role: "admin",
          label: "Admin",
        },
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.username &&
        this.password &&
        this.name &&
        this.phone &&
        this.role
      );
    },
  },
  methods: {
    initValues() {
      if (this.data._id) return;
      this.id = null;
      this.username = "";
      this.password = "";
      this.name = "";
      this.email = "";
      this.phone = "";
      this.role = null;
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            f: this.username.toLowerCase(),
            c: this.password,
            b: this.name,
            a: this.email,
            d: this.phone,
            e: this.role.role,
            g: Date.now(),
            z: 0,
          };
          this.$store
            .dispatch("users/addUser", obj)
            .then(() => {
              this.$vs.notify({
                color: "success",
                title: "User Registered Successfully",
                text: "You have successfully registered a user",
              });
              this.$emit("closeSidebar");
              this.initValues();
            })
            .catch((err) => {
              console.error(err);
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: err,
              });
            });
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
